module.exports = __webpack_public_path__ + "static/media/io.ea42711e.svg";